// LIBRARIES
import styled, { css } from "styled-components";

// MISC
import { BOXSHADOW, COLORS, FONTS } from "constants/styleVariables";

export const EventCardContainer = styled.div(
  ({ photoUrl }) => css`
    display: flex;
    flex-direction: column;
    width: 360px;
    height: 180px;
    justify-content: flex-end;
    border-radius: 15px;
    background-image: url(${photoUrl});
    box-shadow: ${BOXSHADOW.discountCardsBoxShadow};
    margin-bottom: 40px;
    cursor: pointer;
  `
);

export const EventDetailsContainer = styled.div(
  ({ height }) => css`
    background: rgba(41, 52, 98, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    font-size: 14px;
    color: ${COLORS.thirdWhite};
    height: ${height ? height : ""};
    padding: 10px 20px 20px 20px;
    border-radius: 15px;
  `
);
export const Title = styled.text`
  font-family: ${FONTS.newsharp};
  font-weight: bold;
`;
export const Description = styled.text`
  font-family: ${FONTS.montserrat};
  font-weight: 600;
  margin-top: 10px;
`;
export const DatesContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
`;
export const DateContainer = styled.div`
  font-family: ${FONTS.montserrat};
  font-weight: 600;
  font-size: 12px;
`;
export const SlashBar = styled.div`
  margin: 0 5px;
`;
